<template>
  <div class="empty-wrapper">
    <component :is="target" :text="text" />
  </div>
</template>

<script>
import SearchEmpty from './SearchEmpty'
import ListEmpty from './ListEmpty'
import listConfig from '@/data/List'

export default {
  name: 'Empty',
  components: { SearchEmpty, ListEmpty },
  props: {
    isSearch: {
      type: Boolean,
      default: false
    },
    relatedKey: {
      type: String,
      default: ''
    }
  },
  data: () => ({
  }),
  computed: {
    target () {
      return this.isSearch ? SearchEmpty : ListEmpty
    },
    text () {
      const { emptyText } = listConfig[this.relatedKey]
      return emptyText
    }
  }
}
</script>

<style scoped lang="scss">

</style>
